import React from 'react';
import { ChartMode } from '../types';
import * as ChartUI from '../ChartUI';
import ResponsiveChartLoader from './ResponsiveChartLoader';
import { LoadingChartHeader } from '../ChartHeader';

interface IProps {
  mode: ChartMode;
  display?: string;
}

const DEFAULT_DISPLAY = 'Loading chart...';

const ChartLoader = ({ mode, display = DEFAULT_DISPLAY }: IProps) => {
  return (
    <ChartUI.Container>
      <LoadingChartHeader mode={mode} chartTitle={display} />
      <ChartUI.ChartMainWrapper $mode={mode}>
        <ResponsiveChartLoader mode={mode} />
      </ChartUI.ChartMainWrapper>
    </ChartUI.Container>
  );
};

export default ChartLoader;
